module.exports = __webpack_public_path__ + "static/media/tabs-bg-active.70e41e7d.png";